// Danh sách 34 tỉnh/thành phố Việt Nam sau sáp nhập
export const vietnamProvinces = [
  { value: '', label: 'Tất cả tỉnh/thành' },
  { value: 'ha-noi', label: 'Hà Nội' },
  { value: 'hue', label: 'Huế' },
  { value: 'hai-phong', label: 'Hải Phòng' },
  { value: 'da-nang', label: 'Đà Nẵng' },
  { value: 'ho-chi-minh', label: 'Thành phố Hồ Chí Minh' },
  { value: 'can-tho', label: 'Cần Thơ' },
  { value: 'cao-bang', label: 'Cao Bằng' },
  { value: 'dien-bien', label: 'Điện Biên' },
  { value: 'lai-chau', label: 'Lai Châu' },
  { value: 'son-la', label: 'Sơn La' },
  { value: 'lang-son', label: 'Lạng Sơn' },
  { value: 'ha-tinh', label: 'Hà Tĩnh' },
  { value: 'nghe-an', label: 'Nghệ An' },
  { value: 'thanh-hoa', label: 'Thanh Hóa' },
  { value: 'quang-ninh', label: 'Quảng Ninh' },
  { value: 'tuyen-quang', label: 'Tuyên Quang' },
  { value: 'thai-nguyen', label: 'Thái Nguyên' },
  { value: 'lao-cai', label: 'Lào Cai' },
  { value: 'phu-tho', label: 'Phú Thọ' },
  { value: 'bac-ninh', label: 'Bắc Ninh' },
  { value: 'hung-yen', label: 'Hưng Yên' },
  { value: 'ninh-binh', label: 'Ninh Bình' },
  { value: 'quang-tri', label: 'Quảng Trị' },
  { value: 'quang-ngai', label: 'Quảng Ngãi' },
  { value: 'gia-lai', label: 'Gia Lai' },
  { value: 'khanh-hoa', label: 'Khánh Hòa' },
  { value: 'lam-dong', label: 'Lâm Đồng' },
  { value: 'dak-lak', label: 'Đắk Lắk' },
  { value: 'dong-nai', label: 'Đồng Nai' },
  { value: 'tay-ninh', label: 'Tây Ninh' },
  { value: 'vinh-long', label: 'Vĩnh Long' },
  { value: 'dong-thap', label: 'Đồng Tháp' },
  { value: 'ca-mau', label: 'Cà Mau' },
  { value: 'an-giang', label: 'An Giang' }
];

